import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../Login/Login.js';
import AdminShell from './AdminShell';
import {
  loginAndAccessRoutes,
  globalSettingsRoutes,
  darRoutes,
  dataCollectionRoutes,
  dataViewRoutes,
  homeAndAnalyticsRoutes,
  usersRobotsRoutes,
  employeeLeaveRoutes,
  paymentRoutes,
  adminSubscriptionRoutes,
  invoiceRoutes,
  clientDashboardRoutes,
  adminUserDashboardRoutes,
} from './groups';

const adminRoutes = [
  ...loginAndAccessRoutes.filter((r) => r.key !== 'login'),
  ...globalSettingsRoutes,
  ...darRoutes,
  ...dataCollectionRoutes,
  ...dataViewRoutes,
  ...homeAndAnalyticsRoutes,
  ...usersRobotsRoutes,
  ...employeeLeaveRoutes,
  ...paymentRoutes,
  ...adminSubscriptionRoutes,
  ...invoiceRoutes,
  ...adminUserDashboardRoutes,
];

const AfterLoginRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    {clientDashboardRoutes}
    <Route element={<AdminShell />}>{adminRoutes}</Route>
  </Routes>
);

export default AfterLoginRoutes;
